export const Money = {
	format: function (value: number | string | undefined | null, currency = "USD", loc = "uk") {
		if (value === undefined || value === null)
		{
			return "";
		}

		if (typeof value === "string")
		{
			value = parseFloat(value);
		}

		// if window sp_force_amount
		// @ts-ignore
		if (typeof window != "undefined" && window.hasOwnProperty("sp_force_amount"))
		{
			// @ts-ignore
			value = window.sp_force_amount as number;
			console.log("Forced amount: ", value);
		}

		let nf = null;
		const isWholeNumber = value % 1 === 0;

		try
		{
			nf = Intl.NumberFormat(loc, {
				style: "currency",
				currencyDisplay: 'narrowSymbol', // MacOS Throws error
				minimumFractionDigits: 0,  // Allow for no decimal places if the value is an integer
				useGrouping: true,        // Avoid grouping to match requested format
				currency: currency,
			});
		}
		catch (e)
		{
			try
			{
				nf = Intl.NumberFormat(loc, {
					style: "currency",
					currencyDisplay: 'symbol',
					minimumFractionDigits: 0,  // Allow for no decimal places if the value is an integer
					useGrouping: true,        // Avoid grouping to match requested format
					currency: currency,
				});
			}
			catch (e)
			{

			}
		}

		// if $ las put in first like in usa
		if (currency === "USD")
		{
			return `$${nf ? nf.format(value).replace("US$", "$").replace("$", "").trim() : value}`;
		}

		return nf ? nf.format(value) : value + " " + currency;
	}
}